import { NavLink } from 'react-router-dom';

const navItems = [
  { to: '/', label: 'Home' },
  { to: '/portfolio', label: 'My Portfolio' },
  { to: '/redeem', label: 'Redeem' },
  { to: '/how-it-works', label: 'How It Works' },
  { to: '/subscriptions', label: 'Subscriptions' },
];

function shortenPublicKey(publicKey) {
  if (!publicKey) {
    return 'Not connected';
  }

  return `${publicKey.slice(0, 4)}...${publicKey.slice(-4)}`;
}

function Navbar({
  connectionState,
  onConnectWallet,
  onDisconnectWallet,
  phantomInstalled,
  walletConnected,
  walletPublicKey,
}) {
  return (
    <header className="navbar">
      <div className="brand">
        <div className="brand__mark">🔥</div>
        <div>
          <p className="brand__name">SolFire</p>
        </div>
      </div>

      <nav className="navbar__links" aria-label="Primary navigation">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="navbar__actions">
        <div className="wallet-status">
          <span
            className={
              connectionState.error || !phantomInstalled
                ? 'status-pill status-pill--warning'
                : 'status-pill'
            }
          >
            {connectionState.error
              ? 'RPC Error'
              : connectionState.isReady
                ? 'RPC Ready'
                : 'RPC Loading'}
          </span>
          <p className="wallet-copy">
            {connectionState.error
              ? connectionState.error
              : phantomInstalled
              ? walletConnected
                ? `Wallet: ${shortenPublicKey(walletPublicKey)}`
                : 'Wallet: Phantom detected'
              : 'Phantom is not installed'}
          </p>
        </div>

        <button
          className="ghost-button"
          type="button"
          onClick={walletConnected ? onDisconnectWallet : onConnectWallet}
          disabled={!phantomInstalled && !walletConnected}
        >
          {walletConnected ? 'Disconnect Wallet' : 'Connect Wallet'}
        </button>
      </div>
    </header>
  );
}

export default Navbar;